import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { mediaUrl } from "../../data/site";

const diff = (iso) => {
  const ms = Math.max(0, new Date(iso).getTime() - Date.now());
  return [Math.floor(ms / 864e5), Math.floor(ms / 36e5) % 24, Math.floor(ms / 6e4) % 60, Math.floor(ms / 1e3) % 60];
};

const Countdown = ({ date }) => {
  const [parts, setParts] = useState(() => diff(date));
  useEffect(() => {
    const t = setInterval(() => setParts(diff(date)), 1000);
    return () => clearInterval(t);
  }, [date]);
  return (
    <div data-testid="upcoming-countdown" className="grid grid-cols-4 gap-2">
      {["Days", "Hrs", "Min", "Sec"].map((l, i) => (
        <div key={l} className="rounded-2xl border border-[var(--line)] bg-[rgba(7,7,7,0.6)] p-3 text-center backdrop-blur">
          <p className="font-display text-3xl tabular-nums sm:text-4xl">{String(parts[i]).padStart(2, "0")}</p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">{l}</p>
        </div>
      ))}
    </div>
  );
};

export const Upcoming = ({ upcoming }) => {
  const title = upcoming?.title?.trim();
  const date = upcoming?.release_date && !Number.isNaN(new Date(upcoming.release_date).getTime()) ? upcoming.release_date : null;
  const cover = upcoming?.cover ? mediaUrl(upcoming.cover) : null;
  return (
    <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 220, damping: 20 }} data-testid="upcoming-drop-card"
      className="group relative flex h-full min-h-[480px] flex-col justify-between overflow-hidden rounded-[28px] border border-[rgba(182,242,74,0.35)] bg-[var(--ink-2)] p-6 sm:p-8">
      {cover ? <img src={cover} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 blur-[2px]" />
        : <img src="/mae-logo-ink.webp" alt="" aria-hidden className="pointer-events-none absolute -bottom-24 -right-24 w-[420px] opacity-[0.12] animate-spin-slow" />}
      <div className="absolute inset-0 guilloche opacity-60" />
      <div className="relative flex items-center justify-between">
        <span className="flex items-center gap-2 rounded-full bg-[var(--cash)] px-4 py-2 font-mono text-xs font-bold uppercase tracking-[0.2em] text-[var(--ink)]">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[var(--ink)]" /> Next drop
        </span>
        <Lock size={18} className="text-zinc-400" />
      </div>
      <div className="relative">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-400">Money Alwayz Entertainment</p>
        <h3 data-testid="upcoming-title" className="mt-3 font-display text-6xl uppercase leading-[0.88] sm:text-7xl">
          {title || <>Coming<br /><span className="outline-text">Soon</span></>}
        </h3>
        {title && <p className="mt-2 font-serif-i text-3xl text-[var(--cash)]">Coming soon</p>}
        <p className="mt-5 max-w-xs text-zinc-300">{upcoming?.teaser || "Next drop from the Money Alwayz camp."}</p>
        <div className="mt-8">
          {date ? <Countdown date={date} /> : (
            <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-[var(--cash)]">
              <span className="flex gap-1">{[0, 1, 2].map((i) => <motion.span key={i} className="h-2 w-2 rounded-full bg-[var(--cash)]" animate={{ opacity: [0.2, 1, 0.2] }} transition={{ duration: 1.4, repeat: Infinity, delay: i * 0.2 }} />)}</span>
              Date to be announced
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};
